import React from 'react';
import { SellerChangeRequestStatus, ChangeRequestFilterData, FilterItem } from '@/types';
import { Trans } from '@lingui/react/macro';
import { ChangeRequestFilterValue, getInitialChangeRequestFilterValue } from '.';
import { UnitFilter } from '@/seller/components/UnitDropdown/UnitDropdown';
import { useLingui } from '@lingui/react';
import { FilterDropDown, FilterPopOut } from '@ygtechnologies/bygr-frontend-component-library';

interface ChangeRequestFilterProps {
    value: ChangeRequestFilterValue;
    onFilterChange: (f: ChangeRequestFilterValue) => void;
    filterData: ChangeRequestFilterData | null;
    isOpen: boolean;
    onClose: () => void;
    hideStatuses?: boolean;
}

const ChangeRequestFilter: React.FC<ChangeRequestFilterProps> = ({
    value,
    onFilterChange,
    filterData,
    isOpen,
    onClose,
    hideStatuses = false,
}) => {
    const { _ } = useLingui();
    const handleFilterChange = (changes: Partial<ChangeRequestFilterValue>) => {
        onFilterChange({ ...value, ...changes });
    };

    if (!filterData) {
        return null;
    }

    const statuses: FilterItem[] = filterData.statuses.map((cr) => {
        return {
            id: SellerChangeRequestStatus[cr],
            name: _({ id: `ChangeRequestStatus.${cr}` }),
        };
    });

    return (
        <FilterPopOut
            onClear={() => onFilterChange(getInitialChangeRequestFilterValue())}
            onClose={onClose}
            isVisible={isOpen}>
            <FilterDropDown
                data={filterData.groups}
                label={<Trans>Unit groups</Trans>}
                value={value.groups}
                onChange={(v) => handleFilterChange({ groups: v.map((x) => x.id) })}
            />

            <UnitFilter units={filterData.units} value={value.units} onChange={(v) => handleFilterChange({ units: v })} />

            {/* <FilterDropDown
                data={filterData.units}
                placeholder={t`Units`}
                value={value.units}
                onChange={(v) => handleFilterChange({ units: v })}
            /> */}

            {!hideStatuses && (
                <FilterDropDown
                    data={statuses}
                    label={<Trans>Internal statuses</Trans>}
                    value={value.statuses}
                    onChange={(v) => handleFilterChange({ statuses: v.map((x) => x.id) })}
                />
            )}

            <FilterDropDown
                data={filterData.participants}
                label={<Trans>Participants</Trans>}
                value={value.participants}
                onChange={(v) => handleFilterChange({ participants: v.map((x) => x.id) })}
            />
        </FilterPopOut>
    );
};

export default ChangeRequestFilter;
